const type = 'advanced'
const path = '/advance/html-php/'
const name = 'index.php'

export { type, path, name }
